<template>
    <b-modal
        :id="modalId"
        size="xl"
        :title="conversaAtiva ? 'Assunto: ' + conversaAtiva.assunto : ''"
        @hidden="$emit('modal-hidden')"
        hide-footer
        body-class="custom-chat-body"
    >
        <div v-if="deveExibirParticipantes" class="conversa-layout">
            <div class="participantes-sidebar">
                <div class="participantes-header">
                    <h6 class="mb-2">
                        Participantes ({{ participantes.length }})
                    </h6>
                </div>
                <div class="participantes-lista">
                    <div 
                        v-for="participante in participantes" 
                        :key="participante.id" 
                        class="participante-item"
                        :class="{ 'participante-atual': participante.id === usuarioId }"
                    >
                        <div class="participante-avatar">
                            {{ participante.nome.charAt(0).toUpperCase() }}
                        </div>
                        <div class="participante-info">
                            <div class="participante-nome">{{ participante.nome }}</div>
                        </div>
                    </div>
                    <div v-if="participantes.length === 0" class="sem-participantes">
                        <i class="fa fa-users"></i><br>
                        Carregando participantes...
                    </div>
                </div>
            </div>
            
            <div class="chat-principal">
                <mensagens
                    :conversaId="conversaAtiva ? String(conversaAtiva.id) : ''"
                    :usuarioId="usuarioId"
                    :usuario="usuario"
                    @novas-mensagens="$emit('novas-mensagens')"
                    @mensagens-marcadas-como-lidas="onMensagensMarcadasComoLidas"
                />
            </div>
        </div>

        <div v-else class="chat-only-layout">
            <mensagens
                :conversaId="conversaAtiva ? String(conversaAtiva.id) : ''"
                :usuarioId="usuarioId"
                :usuario="usuario"
                @novas-mensagens="$emit('novas-mensagens')"
                @mensagens-marcadas-como-lidas="onMensagensMarcadasComoLidas"
            />
        </div>
    </b-modal>
</template>

<script>
import Mensagens from '../Mensagens.vue'

export default {
    name: 'ModalConversa',
    
    components: {
        Mensagens
    },

    props: {
        modalId: {
            type: String,
            required: true
        },
        conversaAtiva: {
            type: Object,
            default: null
        },
        participantes: {
            type: Array,
            default: () => []
        },
        deveExibirParticipantes: {
            type: Boolean,
            default: true
        },
        usuarioId: {
            type: String,
            required: true
        },
        usuario: {
            type: String,
            required: true
        }
    },

    methods: {
        onMensagensMarcadasComoLidas(evento) {
            this.$emit('mensagens-marcadas-como-lidas', evento)
        }
    }
}
</script>

<style src="../styles/conversas-shared.css"></style>